import { DragEventHandler } from 'react'

interface UseFileDropReturn<T extends HTMLElement> {
  onDrop: DragEventHandler<T>
  onDragOver: DragEventHandler<T>
}
export function useFileDrop<T extends HTMLElement>(
  callback: DragEventHandler<T>
): UseFileDropReturn<T> {
  const onDrop: DragEventHandler<T> = (event) => {
    event.preventDefault()
    event.stopPropagation()

    callback(event)
  }

  const onDragOver: DragEventHandler<T> = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return {
    onDrop,
    onDragOver,
  }
}
